// @ts-strict-ignore
import Link from 'next/link';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';
import { AttentionContainer } from 'src/modules/user/profile/components/shared/sharedStyles';
import MemberCard from 'src/components/memberCard';
type Props = {
  clickOnCard: (href: string, username: string) => void;
};
export default function Followings({
  clickOnCard
}: Props) {
  const {
    profileUser,
    followings
  } = useSelector(({
    pages
  }) => pages.profile);
  const {
    username,
    isOwnProfile,
    isDeceased,
    isUsersImFollowingPublic
  } = profileUser;
  return <>
      {isOwnProfile ? <AttentionContainer as={'span'} margin={'15px 0 10px;'}>
          {!followings.length ? i18n.t('You are not following anyone yet.') : <>
                {i18n.t('Users you follow are')}
                {!isUsersImFollowingPublic ? i18n.t(' hidden from your public profile.') : i18n.t(' visible on your public profile.')}
                <Link href="/settings">{i18n.t(' You can change that here.')}</Link>
              </>}
        </AttentionContainer> : !followings.length && <AttentionContainer as={'span'} margin={'15px 0 0;'}>
            {i18n.t(`${username} does not follow anyone yet.`)}
          </AttentionContainer>}
      {(isOwnProfile || !isDeceased && isUsersImFollowingPublic) && followings?.map(following => <MemberCard isFollowButton={true} key={following.username} member={{
      ...following,
      bio: following?.bio || `Hi! I'm ${following.username}`
    }} onClick={clickOnCard} onFollowClick={() => trackFootfallEvent(Event.Clicked, {
      clickMetadata: {
        section: Section.MemberCardProfileFollowers,
        origin: following.userId === profileUser.userId ? 'own-profile' : 'other-profile'
      },
      clickType: following.isFollowedByCurrentUser ? 'unfollow' : 'follow'
    })} />)}
    </>;
}